import * as React from 'react';
import './StatusSheetPanel.css';
import { inject, observer } from 'mobx-react';
import { AppStore } from '../../../../stores';
import { FilePicker } from '../../../UI/filePicker/FilePicker';
import AdminService from '../../../../services/AdminService';
import RoadmapService from '../../../../services/RoadmapService';

export interface IProps {
  appStore?: AppStore;
  id?: string;
}

export interface IState {
}

@inject('appStore')
@observer
export default class StatusSheetPanel extends React.Component<IProps, IState> {

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {

    return (
      <div>
        <div
          className="statusSheetPanelWrapper"
          style={{
            visibility: this.props.appStore!.statusSheetToEdit != undefined ? "visible" : "hidden"
          }}
          onClick={() => {
            this.props.appStore!.statusSheetToEdit = undefined;
          }}
        />
        <div
          className="statusSheetPanel"
          style={{
            right: this.props.appStore!.statusSheetToEdit != undefined ? 0 : -620
          }}
        >
          <div className="editPanelCloseBtn"
            onClick={() => this.props.appStore!.statusSheetToEdit = undefined}
          />
          <h3>{window.loc.strings.weeklyStatusSheet}</h3>
          <div className="roadmapQuestion">
            <label>Ugenummer*</label>
            <div className="roadmapWeekNumber">{this.props.appStore!.statusSheetToEdit?.weekNumber}</div>
          </div>
          <div className="roadmapQuestion">
            <label>Hvor mange timer har du investeret i dine drømme denne uge?*</label>
            <textarea
              style={{ height: "50px" }}
              onChange={(event: any) => this.props.appStore!.statusSheetToEdit.answers[0] = event.target.value}
              value={this.props.appStore!.statusSheetToEdit?.answers?.[0]}
            />
          </div>
          <div className="roadmapQuestion">
            <label>Hvad har du opnået i denne uge?*</label>
            <textarea
              onChange={(event: any) => this.props.appStore!.statusSheetToEdit.answers[1] = event.target.value}
              value={this.props.appStore!.statusSheetToEdit?.answers?.[1]}
            />
          </div>
          <div className="roadmapQuestion">
            <label>Hvor meget har du faktureret for i denne uge?*</label>
            <textarea
              style={{ height: "50px" }}
              onChange={(event: any) => this.props.appStore!.statusSheetToEdit.answers[2] = event.target.value}
              value={this.props.appStore!.statusSheetToEdit?.answers?.[2]}
            />
          </div>
          <div className="roadmapQuestion">
            <label>Din største succes i denne uge*</label>
            <div className="roadmapQuestionNote">Hvad er du mest stolt af, at du har opnået?</div>
            <div className="roadmapQuestionNote">OBS: Dette deles i Slack tråden med resten af dit hold automatisk.</div>
            <textarea
              style={{ height: "50px" }}
              onChange={(event: any) => this.props.appStore!.statusSheetToEdit.answers[3] = event.target.value}
              value={this.props.appStore!.statusSheetToEdit?.answers?.[3]}
            />
          </div>
          <div className="roadmapQuestion">
            <label> Profilbillede*</label>
            <div className="roadmapQuestionNote">Tag et billede af dig selv hver uge og upload her</div>
            <FilePicker
              darkMode={true}
              url={this.props.appStore!.statusSheetToEdit?.imageUrl}
              showPreview={true}
              style={{
                clear: "both",
                marginBottom: "20px",
              }}
              placeholderText={"Indsæt et link eller upload en billedfil..."}
              inputWidth={this.props.appStore!.isMobile ? "81%" : "87%"}
              onChange={(url: string) => {
                this.props.appStore!.statusSheetToEdit.imageUrl = url;
                if (url && url != undefined && url !== "" && url.indexOf("mindjuice.herokuapp.com/parse/files") !== -1) {
                  const splittedUrl = url.split(".");
                  let fileType = splittedUrl[splittedUrl.length - 1];
                  AdminService.addFile({
                    url: url,
                    fileType: fileType,
                    product: "Weekly Status Sheet",
                    team: undefined,
                    type: "User image"
                  });
                }
              }}
            />
          </div>
          <div
            className='newStatusSheetButton'
            style={{
              clear: "both",
              marginTop: "80px",
              backgroundColor: "#7a12d4",
              color: "white",
              opacity: this.props.appStore!.statusSheetToEdit?.objectId ? 0.5 : 1,
            }}
            onClick={() => {
              if (!this.props.appStore!.statusSheetToEdit?.objectId) {
                RoadmapService.createStatusSheet({
                  answers: this.props.appStore!.statusSheetToEdit.answers,
                  weekNumber: this.props.appStore!.statusSheetToEdit.weekNumber,
                  imageUrl: this.props.appStore!.statusSheetToEdit.imageUrl,
                  ACL: JSON.parse(`{
                                  "*": { "read": false },
                                "${this.props.appStore!.user?.id}": {"read": true, "write": true }
                                }`)
                })
              }
            }}
          >
            {window.loc.strings.save}
          </div>
        </div>
      </div>
    );
  }
}